import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector } from '../hooks';
import { selectEntityState } from '../reducers/entityStatesSlice';
export const EntityTemperature = props => {
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    if (props.entity.title !== 'temperature') {
        return null;
    }
    const value = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'real' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value.toFixed(1) : undefined;
    if (value == undefined) {
        return (_jsx(React.Fragment, { children: "?" }));
    }
    else {
        return (_jsxs(React.Fragment, { children: [value, "\u00B0"] }));
    }
};
